import { Link } from 'react-router-dom';
import { Compass, Facebook, Instagram, Linkedin } from 'lucide-react';
import './ExpandableFooter.css';

function XBrand() {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.64 7.584H.47l8.6-9.835L0 1.154h7.594l5.243 6.932 6.064-6.933Zm-1.29 19.49h2.039L6.487 3.24H4.3L17.61 20.644Z" /></svg>;
}
function TikTokBrand() {
  return <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.59 3.17-5.93 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.64-5.72-.02-.5-.03-1-.01-1.49.18-1.91 1.12-3.74 2.58-4.98 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.08-.14 1.62.24 1.65 1.83 3.04 3.52 2.89 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07Z" /></svg>;
}

// URLs await Ivan. Keep pending accounts as named, non-interactive items.
const SOCIAL_ACCOUNTS = [
  { name: 'Facebook', Icon: Facebook },
  { name: 'X', Icon: XBrand },
  { name: 'Instagram', Icon: Instagram },
  { name: 'TikTok', Icon: TikTokBrand },
  { name: 'LinkedIn', Icon: Linkedin },
];

export default function ExpandableFooter({ paperworkCard = false }) {
  return (
    <footer tabIndex={-1} aria-label="Magellan footer" data-testid="site-footer" data-paperwork-card={paperworkCard} className="expandable-footer">
      <div className="expandable-footer__inner">
        <div className="expandable-footer__top">
          <div className="expandable-footer__brand">
            <Link to="/" className="expandable-footer__logo" aria-label="Magellan home">
              <Compass strokeWidth={1.3} aria-hidden="true" />
              <span>MAGELLAN</span>
            </Link>
          </div>
          <address className="expandable-footer__contact">
            <div><a href="mailto:support@magellan-tms.com">support@magellan-tms.com</a><a href="tel:+14637772573">(463) 777-2573</a></div>
            <p>United States - business mailing address available upon request</p>
          </address>
          <div className="expandable-footer__social">
            <p>Follow us</p>
            <ul aria-label="Social media">
              {SOCIAL_ACCOUNTS.map(({ name, Icon }) => <li key={name}><span role="img" aria-label={name}><Icon aria-hidden="true" /></span></li>)}
            </ul>
          </div>
        </div>
        <div className="expandable-footer__notice">
          <p className="expandable-footer__notice-full">Website content and product materials are educational and operational in nature. They are not legal advice, agency representation, citation defense, court representation, civil penalty response, safety rating appeal, employment-law guidance, contract interpretation, or state-specific legal analysis. Motor carriers should contact qualified legal counsel for legal advice, disputes, citations, penalties, litigation, contracts, employment-law matters, safety rating appeals, and state-specific legal questions.</p>
        </div>
        <div className="expandable-footer__bottom">
          <p className="expandable-footer__copyright">&copy; 2026 Magellan. All rights reserved. <a href="https://iradosavljevic.com/" target="_blank" rel="noreferrer">Ivan Radosavljevic</a></p>
          <nav className="expandable-footer__legal" aria-label="Legal">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-use">Terms of Use</Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
